import { createContext } from 'react';

interface ColorContextProps {
    grayTheme: 'WARM' | 'COOL' ;
}

const ColorContext = createContext<ColorContextProps>({} as ColorContextProps);

export default ColorContext;
